var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrStep3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 15.625H19V12.5H31.5V15.625ZM19 25H31.5V28.125H19V25ZM22.1982 46.875L25.3232 50H0.25V0H37.75V31.3232L34.625 34.4482V3.125H3.375V46.875H22.1982ZM16.9736 10.4736L11.1875 16.2598L6.96387 12.0361L9.16113 9.83887L11.1875 11.8652L14.7764 8.27637L16.9736 10.4736ZM16.9736 22.9736L11.1875 28.7598L6.96387 24.5361L9.16113 22.3389L11.1875 24.3652L14.7764 20.7764L16.9736 22.9736ZM11.1875 36.8652L14.7764 33.2764L16.9736 35.4736L11.1875 41.2598L6.96387 37.0361L9.16113 34.8389L11.1875 36.8652ZM43.5361 35.4736L29.9375 49.0967L23.3701 42.5049L25.5674 40.3076L29.9375 44.6533L41.3389 33.2764L43.5361 35.4736Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrStep3);
export default __webpack_public_path__ + "static/media/qr-step-3.d05dd1caf110d64c4009aee1d8ad70be.svg";
export { ForwardRef as ReactComponent };